import { getRangeValue, resetTerms, TJsonQueryRangeKeys } from '../../../JsonQuery';
import { TTagsManager } from '../types/tag';
import { createTagValue } from './createTagValue';
import { fillLabelTemplate } from './fillLabelTemplate';

interface IParams {
  jsonQueryKey: TJsonQueryRangeKeys;
  template: string;
  id: string;
}

export const createRangeTagManager = ({ jsonQueryKey, template, id }: IParams): TTagsManager => ({
  id,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const rangeValue = getRangeValue(jsonQueryKey)(jsonQuery);

    if (rangeValue === null) {
      return null;
    }

    const { gte, lte } = rangeValue;
    const from = gte ? `от ${gte}` : '';
    const to = lte ? `до ${lte}` : '';
    const rangeText = gte === lte ? to : `${from} ${to}`.trim();

    return [{ label: fillLabelTemplate(template, rangeText), value: createTagValue(id) }];
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms([jsonQueryKey])(jsonQuery),
});
